import { ChevronDown } from "lucide-react";
import { ReactNode, useState } from "react";

type NavSectionProps = {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
};

export function NavSection({ title, children, defaultOpen = true }: NavSectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className="nav-section">
      <button
        className={`nav-section-trigger ${open ? "open" : ""}`}
        type="button"
        onClick={() => setOpen((value) => !value)}
      >
        <span>{title}</span>
        <ChevronDown size={16} />
      </button>
      <div className={`nav-links ${open ? "open" : "closed"}`}>{children}</div>
    </section>
  );
}
